import React, { useEffect, useState, useRef } from "react";
import { X } from "lucide-react";
import Tab from "Common/Components/Tab/Tab";
import TableContainer from "Common/TableContainer";
import Modal from "Common/Components/Modal";
import { getCustomerList } from "../../helpers/fakebackend_helper";
import CustomerModalContent from "./CustomerModalContent";

const CustomerList = () => {
    const [customers, setCustomers] = useState([]);
    const [createdCustomerId, setCreatedCustomerId] = useState<number | null>(null);
    const customerFormRef = useRef<any>(null);
    const addressFormRef = useRef<any>(null);
    const [activeTab, setActiveTab] = useState<string>("customerForm");
    const [openModal, setOpenModal] = useState<boolean>(false);
    const tabOrder = ["customerForm", "addressInfo", "personalInfo", "referencesInfo", "activityInfo", "completed"];
    const resetTabRef = useRef<() => void>();

    const closeToggle = () => {
        setOpenModal(false);
        customerFormRef.current?.resetForm?.();
        addressFormRef.current?.resetForm?.();
        setActiveTab("customerForm");
        resetTabRef.current?.();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const params = {
                    page: 0,
                    size: 1000,
                    sort: "customerId,desc"
                };

                const response = await getCustomerList(params);
                const customersData = response.data?._embedded?.customers || [];
                setCustomers(customersData);
            } catch (error) {
                console.error("Error fetching customers:", error);
            }
        };
        fetchData();
    }, []);

    const columns = [
        {
            header: "Tipo Cliente",
            accessorKey: "typeCustomer.name",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Nombres",
            accessorKey: "names",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Apellidos",
            accessorKey: "surnames",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Apellido Casada",
            accessorKey: "marriedLastName",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Nit",
            accessorKey: "nit",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Email",
            accessorKey: "email",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "DPI",
            accessorKey: "dpi",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Vencimiento DPI",
            accessorKey: "expirationDateDpi",
            enableColumnFilter: false,
            enableSorting: true,
        },
    ];

    const handleSubmitByTab = () => {
        switch (activeTab) {
            case "customerForm":
                customerFormRef.current?.submitForm?.();
                break;
            case "addressInfo":
                if (addressFormRef.current?.hasAddresses?.()) {
                    setActiveTab("personalInfo"); // o goToNextTab() si querés mantener la lógica centralizada
                } else {
                    alert("Debes agregar al menos una dirección antes de continuar.");
                }
                break;
            // Agregar casos para otros formularios si existen
            default:
                console.log("No form to submit");
        }
    };


    return (
        <div className="card">
            <div className="card-body">
                <div className="mb-3">
                    <div className="flex justify-end">
                        <button
                            className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100" id="addRow"
                            onClick={() => setOpenModal(true)}
                        >
                            Agregar Cliente
                        </button>
                    </div>
                    <Modal show={openModal} onHide={closeToggle} id="openModal" modal-center="true"
                        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                        dialogClassName="w-screen max-w-7xl bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full">
                        <Modal.Header className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
                            closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500">
                            <Modal.Title className="text-16">Agregar nuevo cliente</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                        <div className="grid grid-cols-1 2xl:grid-cols-12">
                    <div className="col-span-12 2xl:col-start-3 2xl:col-span-8">
                            <div>
                                <Tab.Container
                                    defaultActiveKey="customerForm"
                                    onTabChange={(key) => setActiveTab(key)}
                                >
                                    <CustomerModalContent
                                        activeTab={activeTab}
                                        setActiveTab={setActiveTab}
                                        tabOrder={tabOrder}
                                        customerFormRef={customerFormRef}
                                        addressFormRef={addressFormRef}
                                        onResetTab={(fn) => (resetTabRef.current = fn)}
                                        setCustomerId={setCreatedCustomerId}
                                        customerId={createdCustomerId}
                                    />
                                </Tab.Container>

                            </div>
                    </div>
                </div>
                        </Modal.Body>
                        <Modal.Footer className="flex items-center justify-end p-4 mt-auto border-t border-slate-200 dark:border-zink-500">
                            <div className="flex justify-end gap-2 mt-5">
                                <button type="button" onClick={closeToggle} className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"><X className="inline-block size-4" /> <span className="align-middle">Cancelar</span></button>
                                <button
                                    onClick={handleSubmitByTab}
                                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                                >
                                Guardar
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
                <TableContainer
                    isPagination={true}
                    isSelect={true}
                    isGlobalFilter={true}
                    columns={columns}
                    data={customers}
                    customPageSize={5}
                    divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                    tableclassName="hover group dataTable w-full text-sm align-middle whitespace-nowrap no-footer"
                    theadclassName="border-b border-slate-200 dark:border-zink-500"
                    trclassName="group-[.stripe]:even:bg-slate-50 group-[.stripe]:dark:even:bg-zink-600 transition-all duration-150 ease-linear group-[.hover]:hover:bg-slate-50 dark:group-[.hover]:hover:bg-zink-600 [&.selected]:bg-custom-500 dark:[&.selected]:bg-custom-500 [&.selected]:text-custom-50 dark:[&.selected]:text-custom-50"
                    thclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500"
                    tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                    PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                />
            </div>

        </div>
    );
};

export default CustomerList;
